// src/ops/types/Dlq.ts
var DlqService = /* @__PURE__ */ ((DlqService2) => {
  DlqService2["Payment"] = "payment";
  DlqService2["Booking"] = "booking";
  DlqService2["Host"] = "host";
  DlqService2["Search"] = "search";
  DlqService2["Chat"] = "chat";
  DlqService2["Notifications"] = "notifications";
  DlqService2["Pricing"] = "pricing";
  return DlqService2;
})(DlqService || {});
var DlqPriority = /* @__PURE__ */ ((DlqPriority2) => {
  DlqPriority2["P0"] = "P0";
  DlqPriority2["P1"] = "P1";
  DlqPriority2["P2"] = "P2";
  DlqPriority2["P3"] = "P3";
  return DlqPriority2;
})(DlqPriority || {});

export {
  DlqService,
  DlqPriority
};
